import { format, parse } from 'date-fns';
import ro from 'date-fns/locale/ro';
import moment from 'moment';

export { ro };
export const DateFormat = 'yyyyMM';

export const newIsoDate = (value: any = undefined) => {
  const date = (value ? new Date(value) : new Date()).toISOString();

  return new Date(date);
};

export const parseDate = (value = '') => {
  if (!value) return new Date();

  return parse(value, DateFormat, newIsoDate());
};

export const formatDate = (value: string = '', dateFormat = 'MMMM yyyy') => {
  if (!value) return '';

  return format(parseDate(value), dateFormat, { locale: ro });
};

export const getCurrentDate = (format: string) => {
  return moment().format(format);
}